import { Injectable }    from '@angular/core';
import { Observable }    from 'rxjs';

import * as _ from 'lodash';
import { RequestService } from '../request.service';

@Injectable()
export class PharmaciesService {

  protected getUsersUrl(): string { return; };
  protected getOneUserUrl(): string { return; };
  protected getBillUrl(): string { return; };

  protected parseObject(obj: any): any { return; };
  protected parseArray(objs: any): any[] { return; };

  constructor(protected requestService: RequestService) { };

  updatePDF(obj: any): Promise<any> {
    return this.requestService.makeRequestImage({
      urlKey: 'pharmaciesPDF',
      method: 'put',
      body: obj
    })
      .then(() => obj);
      
  };



};


// WEBPACK FOOTER //
// ./src/app/services/pharmacies/pharmacies.service.ts